// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"63":"d32e5152","229":"0cd09330","561":"1f87aa72","571":"1c4b41c6"}[chunkId] + ".js";
};